<template>
    <s-v-g-icon :width="width" :height="height" view-box="0 0 521 521">
        <path d="m463.738281 190.894531c-11.230469-24.671875-27.984375-46.445312-49.046875-63.714843v-79.140626h-40.265625c-23.101562 0-44.707031 8.976563-60.765625 24.460938-.113281-39.996094-32.683594-72.5-72.703125-72.5-40.09375 0-72.710937 32.617188-72.710937 72.710938 0 7.765624 1.234375 15.242187 3.5 22.261718-64.96875 20.230469-114.023438 76.898438-123.160156 145.980469-.039063.277344-.082032.554687-.117188.832031h-1.109375c-9.570313 0-17.359375-7.789062-17.359375-17.359375v-17.058593h-30v17.058593c0 26.0625 21.164062 47.277344 47.210938 47.355469 1.300781 31.207031 10.730468 61.382812 27.503906 87.710938 15.90625 24.960937 37.710937 45.496093 63.4375 59.828124v55.621094h96.550781v-33.277344h47.644531v33.277344h96.550782v-50.644531c37.414062-17.964844 67.625-48.777344 84.835937-86.523437h48.265625v-146.878907zm18.261719 116.878907h-38.511719l-3.703125 9.597656c-14.523437 37.621094-44.261718 67.988281-81.585937 83.3125l-9.300781 3.820312v40.4375h-36.550782v-33.277344s-90.808594-.023437-92.21875-.0625l-15.425781-.4375v33.777344h-36.550781v-44.0625l-8.410156-4.113281c-24.429688-11.949219-45.085938-30.414063-59.726563-53.394531-15.03125-23.589844-22.976563-50.921875-22.976563-79.039063 0-81.238281 66.09375-147.332031 147.332032-147.332031h77.921875c2.078125 0 4.359375.0625 6.976562.183594l9.582031.449218 4.425782-8.507812c9.976562-19.171875 29.574218-31.082031 51.148437-31.082031h10.265625v63.917969l5.992188 4.5c22.183594 16.667968 39.160156 39.089843 49.101562 64.835937l3.703125 9.597656h38.511719zm-283.753906-235.0625c0-23.550782 19.160156-42.710938 42.710937-42.710938s42.710938 19.160156 42.710938 42.710938c0 5.007812-.875 9.816406-2.46875 14.289062h-56.824219c-7.824219 0-15.53125.515625-23.089844 1.5-1.953125-4.886719-3.039062-10.210938-3.039062-15.789062zm0 0"/><path d="m352 234.667969h30v30h-30zm0 0"/>
    </s-v-g-icon>
</template>

<script>
    import SVGIcon from "../../../components/SVGIcon";
    export default {
        name: "RevenuesIcon",
        components: {SVGIcon},
        props:{
            width: {
                type: [Number, String],
                default: 32
            },
            height: {
                type: [Number, String],
                default: 32
            },
            color: {
                type: String,
                default: 'currentColor'
            },
        }
    }
</script>

<style scoped>

</style>
